import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import SectionContainer from '../../SectionContainer';

export const BAR_HEIGHT = 80;

export const FooterContainer = styled(SectionContainer)<{ isSmall: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  height: ${`${BAR_HEIGHT}px`};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  ${({ isSmall }) =>
    isSmall &&
    `
    max-width: 1280px;
  `}
`;

export const FooterContent = styled.div`
  flex-grow: 2;
  padding-right: 15px;

  ${media.xs`
    display: none;
  `}
`;

export const FooterPrice = styled.div`
  padding: 0 15px 0 0;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const Title = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 18px;
`;

export const Subtitle = styled.div`
  font-size: 16px;
  margin-top: 5px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;
